import React, { FC } from 'react';
import { ProductCardsContent } from '../ProductCardsContent';
import { RedirectProductCardsProps } from './types';
import { integrationSerApiBaseUrl } from 'api';

const serviceUrl = integrationSerApiBaseUrl();
const RedirectProductCards: FC<RedirectProductCardsProps> = (props) => {
  const onLinkGenerate = (productId: string) => `${serviceUrl}/wp/deposit/redirect/${productId}`;
  return <ProductCardsContent testId="Redirect" {...props} linkGenerator={onLinkGenerate} />;
};

export default RedirectProductCards;
